import { Slot } from '@radix-ui/react-slot';
import { type VariantProps } from 'class-variance-authority';
import * as React from 'react';

import { buttonVariants } from '@/components/ui/buttonVariants';
import { cn } from '@/lib/utils';
import { UNMASK_PROPS } from '@/lib/analytics';

function Button({
  className,
  variant,
  size,
  asChild = false,
  ...props
}: React.ComponentProps<'button'> &
  VariantProps<typeof buttonVariants> & {
    asChild?: boolean;
  }) {
  const Comp = asChild ? Slot : 'button';

  return (
    <Comp
      data-slot="button"
      // Action copy is authored in the codebase, not fetched — readable in
      // replay so a session shows what was clicked. See UNMASK_ATTRIBUTE.
      {...UNMASK_PROPS}
      className={cn(buttonVariants({ variant, size, className }))}
      {...props}
    />
  );
}

export { Button };
